import { render, staticRenderFns } from "./KnowledgeDialog.vue?vue&type=template&id=27f28951&scoped=true"
import script from "./KnowledgeDialog.vue?vue&type=script&lang=js"
export * from "./KnowledgeDialog.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeDialog.vue?vue&type=style&index=0&id=27f28951&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f28951",
  null
  
)

export default component.exports